import { buildQuery } from '../../../utils/query';

// One query builder for the user list, so paging and filtering send the same
// URL: paging went through GET_USERS, which knew nothing about the filters, so
// page 2 of a branch's users came back unfiltered.
const userListQuery = ({ page = 1, rowsPerPage = 10, locationId, role, searchTerm } = {}) =>
  buildQuery({
    page,
    page_size: rowsPerPage,
    location_id: locationId,
    role,
    // The API matches this against the name, email, phone, staff number,
    // department and branch; `name` only ever matched the display name.
    search_term: searchTerm,
  });

export default {
  GET_USERS: (params) => `users/${userListQuery(params)}`,
  GET_STAFF: ({ page = 1, rowsPerPage = 10 }) => `users/staff/?page=${page}&page_size=${rowsPerPage}`,
  GET_SERVICE_PROVIDERS: ({ page = 1, rowsPerPage = 100 }) =>
    `users/?page=${page}&page_size=${rowsPerPage}&role=SERVICE_PROVIDER`,
  GET_BRANCH_MANAGERS: ({ page = 1, rowsPerPage = 100 }) => `users/?page=${page}&page_size=${rowsPerPage}&role=MANAGER`,
  CREATE_USER: 'users/staff/',
  UPDATE_STAFF: (id) => `users/staff/${id}/`,
  DELETE_STAFF: (id) => `users/staff/${id}/`,
  FILTER_USERS: (params) => `users/${userListQuery(params)}`,
};
